import { Field } from 'formik';
import { StyleSheet, View } from 'react-native';

import { FormControlTextInput, Text, XStack, YStack, tokens } from '@fhs/ui';

const DateInputFormik = ({ name, placeholder, maxLength }) => {
  return (
    <Field name={name}>
      {({ field, form, meta }) => {
        return (
          <View style={{ flex: 1, height: 48 }}>
            <FormControlTextInput
              value={field.value}
              placeholder={placeholder}
              accessibilityLabel={`Date of Birth ${placeholder}`}
              maxLength={maxLength}
              keyboardType="numeric"
              onChangeText={newDate => {
                form.setFieldValue(name, newDate);
              }}
              error={Boolean(meta.touched && meta.error)}
              onBlur={form.handleBlur(name)}
              style={styles.dateText}
              readOnly={form.isSubmitting}
            />
          </View>
        );
      }}
    </Field>
  );
};

export const DateOfBirthInputFormik = () => {
  return (
    <Field name="dob">
      {({ form }) => {
        const isError =
          form?.touched?.dob &&
          form?.errors?.dob &&
          ((form.touched.dob.dobYear && form.errors.dob.dobYear) ||
            (form.touched.dob.dobMonth && form.errors.dob.dobMonth) ||
            (form.touched.dob.dobDay && form.errors.dob.dobDay) ||
            form.errors.dob.genericError);
        let errorMessage = '';
        if (isError) {
          if (form.errors.dob.genericError) {
            errorMessage = form.errors.dob.genericError;
          } else if (form.touched.dob.dobYear && form.errors.dob.dobYear) {
            errorMessage = form.errors.dob.dobYear;
          } else if (form.touched.dob.dobMonth && form.errors.dob.dobMonth) {
            errorMessage = form.errors.dob.dobMonth;
          } else if (form.touched.dob.dobDay && form.errors.dob.dobDay) {
            errorMessage = form.errors.dob.dobDay;
          }
        }
        return (
          <YStack>
            <Text weight="semibold"> Date of Birth (Optional)</Text>
            <XStack style={styles.dateContainer}>
              <DateInputFormik name="dob.dobMonth" placeholder="Month" maxLength={2} />
              <DateInputFormik name="dob.dobDay" placeholder="Day" maxLength={2} />
              <DateInputFormik name="dob.dobYear" placeholder="Year" maxLength={4} />
            </XStack>
            {isError && <Text style={styles.errorText}>{errorMessage}</Text>}
          </YStack>
        );
      }}
    </Field>
  );
};

const styles = StyleSheet.create({
  dateContainer: {
    marginVertical: 6,
    gap: 12,
    width: '100%',
    flex: 1,
  },
  dateText: {
    textAlign: 'center',
    width: '100%',
  },
  errorText: {
    color: tokens.colors.$houseRed,
  },
});
